import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { SEND_PAYMENTS_PUBLIC_RECEIPT_EMAIL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  SubmitReceiptEmailRequestPayload,
  SubmitReceiptEmailResult,
} from '../types/submitReceiptEmailRequest.types';

export const submitPublicReceiptEmailRequest = (builder: BuilderType) =>
  builder.mutation<SubmitReceiptEmailResult, SubmitReceiptEmailRequestPayload>({
    query: (params) => ({
      data: params,
      method: 'POST',
      url: SEND_PAYMENTS_PUBLIC_RECEIPT_EMAIL_URL,
    }),
    transformResponse(response: GenericApiResponse<SubmitReceiptEmailResult>) {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
